import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "icon"];
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useMediaQuery } from 'conversations-thread-view/lib/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActionButton = _ref => {
  let {
      children,
      icon
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  // Only show the text on large screens
  const isLargeScreen = useMediaQuery('(min-width: 1212px)');
  return /*#__PURE__*/_jsxs(Button, Object.assign({}, rest, {
    margin: "0 !important",
    paddingInline: "300",
    paddingBlock: "25",
    size: "sm",
    use: "tertiary-light",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: icon,
      size: "300",
      paddingInline: "0"
    }), isLargeScreen && children]
  }));
};
ActionButton.displayName = 'ActionButton';
export default ActionButton;